const {
  REACT_APP_STONE_SF_OAUTH_URL,
  REACT_APP_STONE_SF_CLIENT_ID,
  REACT_APP_CS_PLUGIN_BFF_API_URL,
  REACT_APP_WALLBOARD_API_URL,
  REACT_APP_WALLBOARD_SOCKET_URL,
  REACT_APP_INTERNAL_WALLBOARD_SOCKET_URL,
  REACT_APP_AMPLITUDE_API_KEY
} = process.env

const config = {
  salesforceOauthUrl: REACT_APP_STONE_SF_OAUTH_URL,
  salesforceClientId: REACT_APP_STONE_SF_CLIENT_ID,
  csPluginBffApiUrl: REACT_APP_CS_PLUGIN_BFF_API_URL,
  wallboardApiUrl: REACT_APP_WALLBOARD_API_URL,
  wallboardSocketURL: REACT_APP_WALLBOARD_SOCKET_URL,
  internalWallboardSocketURL: REACT_APP_INTERNAL_WALLBOARD_SOCKET_URL,
  amplitudeApiKey: REACT_APP_AMPLITUDE_API_KEY
}

export default config
